import { parse } from 'date-fns'

import { getAvailability } from './getAvailability'
import { newestToOldest } from './newestToOldest'

export const getFirstAvailable = reservations => {
  if (reservations.length === 0) return null

  const sortedAppointments = reservations.toSorted(newestToOldest)

  const firstAvailableDay = parse(
    sortedAppointments[0].date,
    'yyyy-MM-dd',
    new Date()
  )

  const availability = getAvailability(firstAvailableDay, reservations)

  return {
    date: new Date(firstAvailableDay),
    times: availability?.times,
  }
}
